import { StoryblokVue, apiPlugin } from '@storyblok/vue'
import { StoryblokHelper } from '../lib'

import '../assets/styles/storyblok.scss'

export default defineNuxtPlugin(({ vueApp }) => {
  const runtimeConfig = useRuntimeConfig()
  const accessToken = runtimeConfig.public.storyblokAccessToken

  let enableBridge = false
  const environment = runtimeConfig.public.environment

  if (StoryblokHelper.getEnvironmentVersion(environment) === 'draft')
    enableBridge = true

  vueApp.use(StoryblokVue, {
    accessToken,
    bridge: enableBridge,
    apiOptions: {
      region: 'us',
    },
    use: [apiPlugin],
  })
})
